import { useContext } from "react";
import { PostersContext } from "../../contexts/postersContext";
import { PosterCarousel } from "./PosterCarousel";
import "react-responsive-carousel/lib/styles/carousel.min.css";

export const Services = () => {
  const { data, loading } = useContext(PostersContext);
  const posters = !loading && data?.allPosters;

  if (!posters || !posters.length) return null;

  return (
    <div id="services" className="text-center">
      <span className="servicesAnchor" id="servicesAnchor" aria-hidden="true"></span>
      <div className="container">
        <div className="section-title">
          <h2>Programmes and Appeals</h2>
          <h5>Click on the image to download pdf</h5>
          <PosterCarousel posters={posters} />
        </div>
      </div>
    </div>
  );
};
